import React from 'react';
import { Nav } from 'reactstrap';
import NavItem, { itemPropTypes } from '../components/NavItem';

var ProductNav = function ProductNav(_ref) {
  var active = _ref.active,
      className = _ref.className,
      items = _ref.items,
      site = _ref.site;

  var isActive = function isActive(item) {
    return item.pageKey === active || !item.pageKey && item.name === active;
  };

  return /*#__PURE__*/React.createElement(Nav, {
    className: className,
    navbar: true
  }, (items || []).map(function (item, idx) {
    return /*#__PURE__*/React.createElement(NavItem, {
      isActive: isActive(item),
      item: item,
      key: idx,
      site: site
    });
  }));
};

export default ProductNav;